
import React from 'react';
import { motion } from 'framer-motion';
import { HiDocumentText } from 'react-icons/hi';
// Import PDF icon

const RgpvOrdinace = () => {
  const ordinances = [
    { id: 1, title: '24 Ordinance (1)130516123630', link: 'https://www.gwpcs.org/admin/images/rgpv/24%20ordinance%20(1)130516123630.pdf' },
    { id: 2, title: '24Arevised220120054440 (3)', link: 'https://www.gwpcs.org/admin/images/rgpv/24Arevised220120054440%20(3).pdf' },
    { id: 3, title: 'Ord29271017112922', link: 'path/to/pdf3.pdf' },
    { id: 4, title: 'ORDINANCE22', link: 'https://www.gwpcs.org/admin/images/rgpv/ORDINANCE22.pdf' },
    { id: 5, title: 'ORDINANCE23', link: 'https://www.gwpcs.org/admin/images/rgpv/ORDINANCE23.pdf' },
    { id: 6, title: 'ORDINANCE24', link: 'https://www.gwpcs.org/admin/images/rgpv/ORDINANCE24.pdf' },
    { id: 7, title: 'ORDINANCE25', link: 'https://www.gwpcs.org/admin/images/rgpv/ORDINANCE25.pdf' },
    { id: 8, title: 'ORDINANCE26', link: 'https://www.gwpcs.org/admin/images/rgpv/ORDINANCE26.pdf' },
    { id: 9, title: 'ORDINANCE27', link: 'https://www.gwpcs.org/admin/images/rgpv/ORDINANCE27.pdf' },
    { id: 10, title: 'ORDINANCE28', link: 'https://www.gwpcs.org/admin/images/rgpv/ORDINANCE28.pdf' },
  ];

  return (
    <div className="flex flex-col justify-center items-center p-12 bg-gray-100 min-h-screen">
      <h1 className="text-3xl font-bold text-teal-500 mb-10">RGPV ORDINANCE</h1> {/* Heading added here */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 max-w-7xl w-full">
        {ordinances.map((ordinance) => (
          <motion.div
            key={ordinance.id}
            className="bg-white rounded-lg shadow-lg overflow-hidden transform hover:scale-105 transition-transform duration-300"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 * ordinance.id }}
          >
            <div className="flex justify-center items-center bg-teal-500 p-6">
              <HiDocumentText className="text-white w-16 h-16" /> {/* PDF Icon */}
            </div>
            <div className="p-4">
              <div className="text-center mb-4">
                <span className="text-lg font-semibold text-teal-500">{ordinance.title}</span>
              </div>
              <div className="mb-4 flex justify-center">
                <HiDocumentText className="w-10 h-10 text-teal-500" /> {/* PDF Icon */}
              </div>
              <a
                href={ordinance.link}
                target="_blank"
                rel="noopener noreferrer"
                className="block text-center bg-teal-500 text-white font-semibold py-2 px-4 rounded-lg hover:bg-teal-600 transition"
              >
                View
              </a>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default RgpvOrdinace;

